<template>
	<div class="mbp">
		<div class="mbp__overlay" @click="hiddenModal"></div>

		<!-- Modal -->
		<div class="mbp__modal">
			<!-- ////////////////// -->
			<!-- Оплата -->
			<div
				v-for="(item, index) in items"
				:key="index"
				:class="
					index === ICON.CHANNELS
						? 'mbp__modal-row_line'
						: 'mbp__modal-row'
				"
			>
				<div class="mbp__modal-row-col">
					<div class="mbp__modal-row-col-icon">
						<IconPayment v-if="ICON.PAY === index" />
						<IconChannels
							v-if="ICON.CHANNELS === index"
							color="rgb(188, 192, 207)"
						/>
						<!-- TODO временно -->
						<!--						<IconSettingsProfile v-if="ICON.PROFILE === index" />-->
						<IconExit v-if="ICON.EXIT === index" />
					</div>
					<div
						@click="onClickRedirect(item.routeName)"
						class="mbp__modal-row-col-label"
					>
						{{ item.name }}
					</div>
				</div>
				<div v-if="ICON.CHANNELS === index" class="mbp__modal-row-num">
					{{ item.num }}
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { mapActions } from "vuex";
import { IModal } from "@/interfaces/IModal";
import IconPayment from "@/components/icons/IconPayment.vue";
import IconChannels from "@/components/icons/IconChannels.vue";
import IconSettingsProfile from "@/components/icons/IconSettingsProfile.vue";
import IconExit from "@/components/icons/IconExit.vue";

@Options({
	components: { IconExit, IconSettingsProfile, IconChannels, IconPayment },
	props: {
		balance: { type: String, default: "" },
		channels: { type: Number, default: 0 },
		tariffType: { type: Number, default: 0 },
	},
	methods: {
		...mapActions("instanceModule", ["modalProfileAction"]),
		...mapActions("authModule", ["checkAuthAction", "logoutAction"]),
	},
})
export default class ModalBottomProfile extends Vue {
	// TODO - временно
	// public ICON = { PAY: 0, CHANNELS: 1, PROFILE: 2, EXIT: 3 };
	public ICON = {};

	// Props declaration
	public channels: number;
	public tariffType: number;

	// Const declaration
	public readonly TARIFF = { FREE: 1 };

	public items: Array<{
		id: number;
		name: string;
		num?: number;
		routeName: string;
	}> = [];

	// ************************************************************
	// Define mapActions
	public modalProfileAction!: (payload: IModal) => void;
	public checkAuthAction!: () => void;
	public logoutAction!: () => Promise<void>;

	public mounted() {
		this.items = [
			// TODO - временно
			// {
			// 	id: 0,
			// 	name: "Баланс",
			// 	num: "1000 руб.",
			// 	routeName: "payment",
			// },
			{
				id: 0,
				name: "Каналы",
				num: this.numChannels,
				routeName: "payment",
			},
			// TODO - временно
			// {
			// 	id: 2,
			// 	name: "Настройки профиля",
			// 	num: "",
			// 	routeName: "setting-profile",
			// },
			{
				id: 1,
				name: "Выйти",
				num: 0,
				routeName: "login",
			},
		];

		if (this.tariffType === this.TARIFF.FREE) {
			// Удаляем оплату из списка
			this.items.splice(0, 1);
			this.ICON = { EXIT: 0 };
		} else {
			this.ICON = { CHANNELS: 0, EXIT: 1 };
		}
	}

	/**
	 * Скрывает модальное окно
	 */
	public hiddenModal() {
		this.modalProfileAction({ isShow: false });
	}

	public get numChannels() {
		return this.channels;
	}

	/**
	 * Переход на другую страницу
	 * @param routeName
	 * @param id
	 */
	public async onClickRedirect(routeName: string, id?: number) {
		if (routeName === "login") {
			await this.logoutAction();
			await this.checkAuthAction();
		}
		this.$router.push({ name: routeName, params: { id: id } });
		this.hiddenModal();
	}
}
</script>

<style scoped lang="scss">
.mbp {
	user-select: none;
	&__overlay {
		display: block;
		position: fixed;
		z-index: 1;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		overflow: auto;
		background-color: rgba(0, 0, 0, 0.4);
	}

	&__modal {
		display: block;
		position: fixed;
		z-index: 2;
		left: 0;
		bottom: 0;
		background-color: rgb(255, 255, 255);
		border: 1px solid rgb(255, 255, 255);
		border-top-left-radius: 16px;
		border-top-right-radius: 16px;
		width: 100%;
		min-height: 90px;

		// Анимация
		animation-duration: 0.4s;
		animation-name: appearance-animation-modal;
	}

	&__modal-row {
		display: flex;
		padding: 16px 16px;
		align-items: center;
		justify-content: space-between;
	}

	&__modal-row_line {
		display: flex;
		padding: 16px 16px;
		align-items: center;
		justify-content: space-between;
		/* TODO - временно закомментировано */
		//border-bottom: 1px solid rgb(223, 230, 238);
	}

	&__modal-row-col {
		display: flex;
		align-items: center;
	}

	&__modal-row-col-label {
		padding-left: 12px;
		color: rgb(49, 49, 50);
		font-size: 16px;
	}

	&__modal-row-num {
		font-size: 16px;
		font-weight: 600;
		color: rgb(49, 49, 50);
	}
}

@keyframes appearance-animation-modal {
	0% {
		opacity: 0;
		transform: translate(0, 140px);
	}
	100% {
		opacity: 1;
		transform: translate(0, 0);
	}
}
</style>
